import React from "react";
import LegalLayout from "../components/site/LegalLayout";
import { COMPANY } from "../data/site";

export default function Terms() {
  return (
    <LegalLayout
      title="Terms & Conditions"
      eyebrow="Legal"
      testId="terms-page"
    >
      <p>
        These Terms & Conditions (“Terms”) govern your access to and use of the
        JayesPay web and mobile applications operated by {COMPANY.legalName}{" "}
        (CIN: {COMPANY.cin}) (“{COMPANY.name}”, “we”, “us”, “our”). By
        registering or using JayesPay, you agree to these Terms.
      </p>

      <h2>1. Eligibility</h2>
      <p>
        You must be 18 years or older and competent to enter a binding contract
        under Indian law to use JayesPay as a retailer.
      </p>

      <h2>2. Account & KYC</h2>
      <ul>
        <li>
          You agree to provide accurate and complete information during
          registration and KYC (Aadhaar eKYC, PAN, Bank, documents).
        </li>
        <li>
          You are responsible for safeguarding your password, T-PIN and App
          Lock PIN.
        </li>
        <li>
          {COMPANY.name} may suspend or terminate accounts for non-compliance,
          suspicious activity or violation of law.
        </li>
      </ul>

      <h2>3. Services</h2>
      <p>
        JayesPay facilitates retailer access to recharge, bill payments, PAN
        applications, NSDL Bank BC, RD and other services. These are delivered
        by regulated third-party operators/billers/banks; their terms apply in
        addition to ours.
      </p>

      <h2>4. Wallet & Transactions</h2>
      <ul>
        <li>
          Your JayesPay wallet is a pre-paid balance within the app; it is not a bank account.
        </li>
        <li>
          Add money methods include Manual Request, UPI/Bank Transfer and
          Instant UPI Payment.
        </li>
        <li>
          You must verify customer details and amounts before confirming a
          transaction. {COMPANY.name} is not responsible for losses arising
          from incorrect entries.
        </li>
      </ul>

      <h2>5. Commission & Packages</h2>
      <p>
        Commission rates are visible per service inside the app and may be
        updated from time to time. Service-activation packages are
        non-refundable once activated.
      </p>

      <h2>6. Acceptable Use</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Use the Platform for any unlawful, fraudulent or money-laundering activity.</li>
        <li>Resell, scrape or reverse-engineer the Platform.</li>
        <li>Impersonate any person or misuse another retailer&apos;s account.</li>
      </ul>

      <h2>7. Intellectual Property</h2>
      <p>
        All trademarks, logos, code, content and designs on the Platform are
        owned by {COMPANY.legalName} or its licensors. You may not copy or use
        them without written permission.
      </p>

      <h2>8. Limitation of Liability</h2>
      <p>
        To the maximum extent permitted by law, {COMPANY.name} shall not be
        liable for indirect, incidental, special or consequential damages, or
        for losses arising from third-party operator failures, network issues,
        or incorrect details submitted by you or your customers.
      </p>

      <h2>9. Indemnity</h2>
      <p>
        You agree to indemnify and hold {COMPANY.legalName}, its directors,
        officers and employees harmless from claims arising out of your
        violation of these Terms or applicable law.
      </p>

      <h2>10. Governing Law & Jurisdiction</h2>
      <p>
        These Terms are governed by the laws of India. Courts at Gaya, Bihar
        shall have exclusive jurisdiction.
      </p>

      <h2>11. Changes</h2>
      <p>
        We may update these Terms; the latest version is always available on
        this page. Continued use means acceptance.
      </p>

      <h2>12. Contact</h2>
      <p>
        Questions about these Terms: <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>{" "}
        · {COMPANY.phone}.
      </p>
    </LegalLayout>
  );
}
